// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layoutContainer{
    width:100%;
    height: 100%;
}
.navb nav ul li {
    text-align: left;
    color: #fff;
    list-style-type: none;
    margin: 14px;
}
.navb nav ul li:first-child {
    margin-top: 0 !important;
}
.navb nav ul{
    text-align: left;
    padding-left: 0;
    margin-top: 0;
}
.navb{
    margin-left: 0;
    text-align: left;
}
.navb nav ul li a{
    width:100px !important;
    color: #BBBCBD!important;
    text-decoration: none !important;
    font-size: 18px;
  }
.navb nav ul li a:focus {
    background-color: #4996EE;
  }`, "",{"version":3,"sources":["webpack://./src/components/TicketingComponents/layout.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,gCAAgC;IAChC,eAAe;EACjB;AACF;IACI,yBAAyB;EAC3B","sourcesContent":[".layoutContainer{\n    width:100%;\n    height: 100%;\n}\n.navb nav ul li {\n    text-align: left;\n    color: #fff;\n    list-style-type: none;\n    margin: 14px;\n}\n.navb nav ul li:first-child {\n    margin-top: 0 !important;\n}\n.navb nav ul{\n    text-align: left;\n    padding-left: 0;\n    margin-top: 0;\n}\n.navb{\n    margin-left: 0;\n    text-align: left;\n}\n.navb nav ul li a{\n    width:100px !important;\n    color: #BBBCBD!important;\n    text-decoration: none !important;\n    font-size: 18px;\n  }\n.navb nav ul li a:focus {\n    background-color: #4996EE;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
